import React, {Component} from 'react';
import WOW from 'wowjs';
import UserHomeTableOrders from './user-home-table-orders';
import UserHomeTableTransactions from './user-home-table-transactions';
import UserHomeTableProfile from './user-home-table-profile';


class UserHomeTable extends Component{

    componentDidMount() {
        new WOW.WOW().init();
      }

    render(){

        return(
            <div className="my-account">
                <div className="container">
                   <div className="my-account-title">حسابي</div>
                    <div className="my-account-main">
                        <ul className="nav nav-tabs main-tabs" id="myAccount" role="tablist">
                            <li className="nav-item"> <a  className="nav-link active" id="history-tab" data-toggle="tab" href="#history" role="tab" aria-selected="true">الطلبات</a> </li>
                            <li className="nav-item"> <a className="nav-link" id="transactions-tab" data-toggle="tab" href="#transactions" role="tab"  aria-selected="false">المعاملات</a> </li>
                            <li className="nav-item"> <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab"  aria-selected="false">الملف الشخصي</a> </li>
                            <li className="nav-item"> <a className="nav-link"  href="/home" onClick = {() => localStorage["token"] = "null" } >تسجيل خروج</a> </li>
                        </ul>
                        <div className="tab-content" id="myAccountContent">
                            <UserHomeTableOrders/>
                            <UserHomeTableTransactions/>
                            <UserHomeTableProfile/>
                        </div>
        
                   
                    </div>
        
                
                </div>
            </div>
        );
       
    }

};
export default UserHomeTable;


